import { useNavigationContainerRef } from "expo-router"
import { useEffect, useState } from "react"

/**
 * True once the root navigator accepts imperative navigation.
 *
 * A screen's mount effect runs before the navigation container's own effect on
 * a cold page load, so redirecting from one throws "Attempted to navigate
 * before mounting the Root Layout component" and strands the user.
 */
export function useNavigationReady(): boolean {
  const navigationRef = useNavigationContainerRef()
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (isReady) return

    let frame: number | undefined

    const check = () => {
      if (navigationRef.current?.isReady()) {
        setIsReady(true)
        return
      }
      frame = requestAnimationFrame(check)
    }

    check()

    return () => {
      if (frame !== undefined) cancelAnimationFrame(frame)
    }
  }, [isReady, navigationRef])

  return isReady
}
